module.exports = __webpack_public_path__ + "static/media/admin.0bc86555.png";